<template>
    <div
        id="filter-bar" class="dap-page-filter" v-if="options"
        v-on-click-away="closeFilter">

        <div class="filter-body" v-if="showFilter">
            <FilterPanel
                ref="filterPanel"
                :size="size"
                :effectMap="effectMap"
                @changeTemp="handleChangeTemp"
                @changeFilter="handleChangeFilter"
                @close="closeFilter" @clearAll="$emit('clearAll')">
                <slot v-for="item in slotNames" :slot="item" :name="item"></slot>
            </FilterPanel>
        </div>

        <slot name="left"></slot>

        <el-button :size="size" @click="handleShowFilter" class="filter-btn m-b-10 m-r-10" v-if="subOptionsList.length > 1">
            <div class="flex-center">
                <div>筛选条件</div>
                <i class="m-l-5 filter-btn-icon"><DapIconSvg icon-class="tianjia1" class="f12"/></i>
            </div>
        </el-button>

        <div
            v-else-if="subOptionsList.length === 1" class="single-filter-bar flex-normal bg-white m-r-10"
            :style="{height: calcHeight}"
        >
            <div class="single-filter-name flex-center c-333 f12 fw-400">{{subOptionsList[0].name}}</div>
            <div class="single-filter-content">
                <FilterItem
                    :filterOption="subOptionsList[0]" :selectedDict="filterData" hideBorder hideName :width="100"
                    @setResult="setSingleResult" :size="size">
                </FilterItem>
            </div>
        </div>

        <div
            class="inline-block search-input m-r-10 m-b-10" v-if="options.search"
            :class="[ options.search.length > 1 ? 'w300' : 'w200']">

            <el-input
                class="bg-white f12" v-model="search" :placeholder="placeholder"
                @keyup.enter.native="handleSearch" style="border-radius: 4px;" :size="size">

                <el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>

                <el-select
                    v-model="searchType" slot="prepend" placeholder="请选择" :popper-append-to-body="false"
                    v-if="options.search.length > 1">
                    <el-option
                        :label="item.name" :value="item.key"
                        v-for="item in options.search" :key="item.key">
                        {{ item.name }}
                    </el-option>
                </el-select>
            </el-input>
        </div>
        <FilterBar
            v-for="(item) in this.sortedResult" :key="item.key"
            :size="size"
            :hide="hideAll" :selectKey="item.key"
            :overrideSearchMapper="overrideSearchMapper"
            @removeResult="removeResult"
            @setResult="handleSetResult">
        </FilterBar>
        <div
            class="hide-bar inline-block m-b-10 f12" :style="{height: calcHeight, lineHeight: calcHeight}"
            v-if="filterLength > 1 && showQuickHide"
            @click="toHide">
            {{ hideAll ? `展开${filterLength}个筛选条件` : '收起筛选结果' }}
        </div>

    </div>
</template>

<script>
import FilterPanel from './components/FilterPanel';
import FilterBar from './components/FilterBar';
import FilterItem from './components/FilterItem';
import DapIconSvg from '../../icon-svg';
import { directive as onClickAway } from 'vue-clickaway';

export default {
    name: 'DapPageFilter',
    components: {
        FilterPanel,
        FilterBar,
        FilterItem,
        DapIconSvg,
    },
    directives: {
        onClickAway: onClickAway,
    },

    props: {
        options: {
            type: Object,
            default: () => null,
        },
        filterData: {
            type: Object,
            default: () => {},
        },
        size: {
            type: String,
            default: 'mini',
        },
        showQuickHide: {
            type: Boolean,
            default: true,
        },
        overrideSearch: {
            type: Boolean,
            default: false,
        },
        overrideSearchMapper: {
            type: Object,
            default: () => ({ search: 'search', searchType: 'searchType' }),
        },
        effectMap: Object,
    },

    provide () {
        return {
            filterData: () => this.filterData,
            options: () => this.options,
            result: () => this.result,
            unremoveKeys: () => this.unremoveKeys,
            // 排除功能
            excludeSelectedItems: () => this.excludeSelectedItems,
            operationList: [
                { value: 'GREATER_THAN', label: '大于' },
                { value: 'GREATER_THAN_EQUAL', label: '大于等于' },
                { value: 'LESS_THAN', label: '小于' },
                { value: 'LESS_THAN_EQUAL', label: '小于等于' },
                { value: 'BETWEEN', label: '介于' },
                { value: 'EQUALS', label: '等于' },
                { value: 'IN', label: '多选' },
                { value: 'NOT_IN', label: '排除' },
            ],
        };
    },

    mounted () {
        // this.initSearch();
    },
    computed: {
        result () {
            let result = {};
            if (this.subOptionsList.length > 1) {
                for (let i = 0; i < this.subOptionsList.length; i++) {
                    const key = this.subOptionsList[i].key;
                    const value = this.filterData[key];
                    if (!value ||
                        (Array.isArray(value) && value.length === 0) ||
                        (this.isObj(value) && Object.keys(value).length === 0)
                    ) {
                        if (this.unremoveKeys.includes(key)) {
                            result[key] = null;
                        }
                        continue;
                    }
                    result[key] = value;
                }
            }
            if (this.options.search) {
                if (this.overrideSearch && this.filterData[this.overrideSearchMapper.search]) {
                    result[this.overrideSearchMapper.search] = this.filterData[this.overrideSearchMapper.search];
                } else {
                    for (let i = 0; i < this.options.search.length; i++) {
                        const key = this.options.search[i].key;
                        if (this.filterData[key]) {
                            result[key] = this.filterData[key];
                        }
                    }
                }
            }
            if (this.options.others) {
                for (let i = 0; i < this.options.others.length; i++) {
                    const key = this.options.others[i].key;
                    if (this.filterData[key]) {
                        result[key] = this.filterData[key];
                    }
                }
            }
            if (this.options.metrics) {
                for (let metricGroup of this.options.metrics) {
                    for (let metric of metricGroup.children) {
                        const key = metric.key;
                        if (this.filterData[key]) {
                            result[key] = this.filterData[key];
                        }
                    }
                }
            }
            return Object.assign({}, result);
        },
        filterLength () {
            const allOptions = this.subOptionsList.concat(this.options.search || []).concat({ key: this.overrideSearchMapper.search}).concat(this.metricList);
            return Object.keys(this.result).filter(key => {
                const option = allOptions.find(i => i.key === key);
                return !option.hideRes && !option.hide;
            }).length;
        },

        excludeSelectedItems () {
            let result = {};
            if (this.subOptionsList.length > 1) {
                for (let i = 0; i < this.subOptionsList.length; i++) {
                    // 开启了 排除已选功能 值回填
                    const item = this.subOptionsList[i];
                    if(item.type === 'multiModal' && item.showExcludeSelected){
                        result[item.excludeSelectedKey] = this.filterData[item.excludeSelectedKey];
                    }
                }
            }
            return Object.assign({}, result);
        },

        placeholder () {
            if (this.options.search && this.searchType) {
                return this.options.search.find(i => i.key === this.searchType).placeholder;
            }
            return '';
        },
        slotNames () {
            return this.subOptionsList.filter(i => i.type === 'slot').map(i => i.key);
        },
        subOptionsList () {
            return this.options.filters.reduce((res, item) => [...res, ...item.children], []).filter(i => !i.hide);
        },
        metricList () {
            return this.options && this.options.metrics ? this.options.metrics.reduce((res, item) => [...item.children, ...res], []) : [];
        },
        calcHeight () {
            return {
                mini: '26px',
                small: '30px',
            }[this.size];
        },
        keyList () {
            // searchKey + filterKey + metricKey
            return (this.options.search || []).map(i => i.key).concat((this.subOptionsList || []).map(i => i.key), this.metricList.map(i => i.key));
        },
        // 根据keyList排序后的result
        sortedResult () {
            const resultKeys = this.unremoveKeys.concat(Object.keys(this.result));
            // 去重
            return [...new Set(resultKeys)].sort((a, b) => this.keyList.indexOf(a) - this.keyList.indexOf(b)).map(key => ({
                key,
                value: this.result[key],
            }));
        },

        // 不能被清除的key
        unremoveKeys () {
            return this.options.filters.filter(i => i.clearable === false).reduce((res, i) => (
                [...res, ...i.children]
            ), []).map(i => i.key);
        },
    },

    data () {
        return {
            showFilter: false,
            search: '',
            hideAll: false,
            searchType: '',
        };
    },
    methods: {
        isObj (obj) {
            return Object.prototype.toString.call(obj) === '[object Object]';
        },
        initSearch () {
            if (this.options.search) {
                this.searchType = this.options.search[0].key;
            }
        },

        handleShowFilter () {
            this.showFilter = !this.showFilter;
            if (this.showFilter) {
                this.$emit('openPanel');
            }
        },

        closeFilter () {
            this.showFilter = false;
            this.$emit('changeTemp', { selectType: '', value: '', selectDict: {} });
        },

        getFilterItem (key) {
            const subOptionsList = this.options.filters.reduce((res, item) => [...item.children, ...res], []);
            return subOptionsList.find(i => i.key === key) || {};
        },

        refreshEffect (type, changeDict, excludeObject = {}) {
            if (this.effectMap && this.effectMap[type]) {
                this.effectMap[type].map(item => {
                    changeDict[item] = undefined;
                    // 包含排除功能 - 所有关联的筛选项默认设置为false
                    const filterItem = this.getFilterItem(item);
                    if (filterItem.showExcludeSelected) {
                        changeDict[filterItem.excludeSelectedKey] = false;
                    }
                });
            }
            // 多选弹框并且开启了排除功能
            if (excludeObject.excludeKey) {
                changeDict[excludeObject.excludeKey] = excludeObject.excludeValue;
            }
            this.$emit('change', changeDict);
        },

        handleChangeTemp (value) {
            this.$emit('changeTemp', value);
        },

        handleChangeFilter (value) {
            this.$emit('change', value);
        },

        handleSetResult (value, excludeSelectedKey, exclude) {
            this.$emit('changeResultBar', value);
            // this.$emit('change', value);
            this.refreshEffect(Object.keys(value)[0], value, { excludeKey: excludeSelectedKey, excludeValue: exclude });
        },

        removeResult (type) {
            this.$emit('changeResultBar', { [type]: undefined });
            this.refreshEffect(type, { [type]: undefined });
        },

        setSingleResult (res) {
            this.$emit('change', { [res.selectType]: res.value });
        },

        handleSearch () {
            if (this.search) {
                if (this.overrideSearch) {
                    this.$emit('change', {
                        [this.overrideSearchMapper.search]: this.search,
                        [this.overrideSearchMapper.searchType]: this.searchType,
                    });
                } else {
                    this.$emit('change', { [this.searchType]: this.search });
                }
                this.search = '';
            }
        },

        toHide () {
            this.hideAll = !this.hideAll;
        },
    },
    watch: {
        'options.search': {
            handler (val, oldVal) {
                if (JSON.stringify(val) !== JSON.stringify(oldVal)) {
                    this.initSearch();
                }
            },
            deep: true,
            immediate: true,
        }
    }
};
</script>

<style lang="scss">
.dap-page-filter {

    position: relative;
    display: flex;
    flex-wrap: wrap;
    margin: 0;

    .filter-body {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
    }

    .filter-btn {
        width: 100px;
        border: 1px dashed rgba(153,153,153,1);
        &:hover, &:focus {
            background-color: #fff;
            border-color: #409EFF;
            .filter-btn-icon {
                color: #409EFF;
            }
        }
    }

    > .single-filter-bar {
        border-radius: 4px;
        border: 1px solid #EBEEF5;
        .single-filter-name {
            border-right: 1px solid #EBEEF5;
            padding: 0 20px;
            height: 100%;
        }
        .single-filter-content {
            flex: auto;
        }
        .el-select .el-input__inner {
            border: none;
            background-color: transparent;
        }
    }

    .search-input {
        border-radius: 4px;
        .el-input-group__append {
            padding: 0 10px;
            background-color: #fff;

        }
        .el-input-group__prepend {
            width: 100px;
            font-size: 12px;
            background-color: #fff;
            color: #606266;
            box-sizing: border-box;
        }
        .el-select-dropdown__item {
            font-size: 12px;
        }
    }

    .hide-bar {
        margin-bottom: 0;
        border-radius: 4px;
        color: #999999;
        border: 1px #DDDFE6 solid;
        padding: 0 5px;
        cursor: pointer;
    }

    input::-webkit-input-placeholder {
        font-size: 12px !important;
    }
}

.dap-page-filter, .metric-popover {
    .el-select {
        &.operation-select {
            .el-input__inner {
                padding-left: 10px;
                padding-right: 25px;
            }
        }
    }

    .el-input {
        &.no-border {
            .el-input__inner {
                border-color: transparent;
                height: 25px;
            }
        }
    }

    .range-input {
        box-sizing: border-box;
        border: 1px solid #DCDFE6;
        outline: 1px #DCDFE6;
        border-radius: 4px;
        height: 28px;
        z-index: 100;
    }

    .el-form-item__content {
        line-height: 28px;
    }
}
</style>
